export default function ProviderQuickAccess() {
  const providers = [
    {
      name: 'Pragmatic Play',
      image: 'https://readdy.ai/api/search-image?query=pragmatic%20play%20slot%20game%20interface%20with%20vibrant%20colorful%20reels%2C%20golden%20coins%2C%20jackpot%20symbols%2C%20professional%20casino%20game%20UI%2C%20neon%20border%20glow%20effect%2C%20dark%20background%20with%20purple%20and%20gold%20accents&width=420&height=180&seq=provider-card-001&orientation=landscape',
      color: '#EFBF65'
    },
    {
      name: 'PG SOFT (Coming Soon)',
      image: 'https://readdy.ai/api/search-image?query=pg%20soft%20asian%20themed%20slot%20game%20interface%2C%20mahjong%20tiles%2C%20fortune%20symbols%2C%20colorful%20game%20UI%20with%20neon%20glow%2C%20dark%20background%20with%20blue%20and%20gold%20highlights&width=420&height=180&seq=provider-card-002&orientation=landscape',
      color: '#29A5FF'
    },
    {
      name: 'CQ9 (Coming Soon)',
      image: 'https://readdy.ai/api/search-image?query=cq9%20gaming%20dragon%20themed%20slot%20interface%2C%20chinese%20symbols%2C%20fire%20effects%2C%20vibrant%20casino%20game%20UI%20with%20neon%20border%2C%20dark%20background%20with%20red%20and%20gold%20tones&width=420&height=180&seq=provider-card-003&orientation=landscape',
      color: '#4B3FAE'
    },
    {
      name: "Play'n GO (Coming Soon)",
      image: 'https://readdy.ai/api/search-image?query=play%20n%20go%20egyptian%20themed%20slot%20game%20interface%2C%20book%20of%20dead%20style%2C%20ancient%20symbols%2C%20vibrant%20casino%20UI%20with%20neon%20glow%2C%20dark%20background%20with%20gold%20accents&width=420&height=180&seq=provider-card-004&orientation=landscape',
      color: '#EFBF65'
    }
  ];

  const handleScroll = () => {
    document.getElementById('winners')?.scrollIntoView({ behavior: 'smooth', block: "start" });
  };

  return (
    <section className="py-12 lg:py-16 bg-gradient-to-b from-[#0D0E11] to-[#111319]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {providers.map((provider, index) => (
            <div
              key={index}
              className="group relative bg-[#16181D] rounded-[18px] overflow-hidden border-2 border-[#29A5FF]/30 hover:border-[#EFBF65] hover:scale-105 hover:shadow-[0px_6px_14px_rgba(0,0,0,0.45)] transition-all duration-300"
              style={{ height: '180px' }}
              onClick={handleScroll}
            >
              <div className="w-full h-full overflow-hidden">
                <img
                  src={provider.image}
                  alt={provider.name}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white font-bold text-lg mb-2" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                  {provider.name}
                </h3>
                <button
                  className="text-[#EFBF65] hover:text-white text-sm font-semibold flex items-center gap-2 transition-colors duration-300 cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Explore Games
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
              <div
                className="absolute top-0 right-0 w-24 h-24 opacity-20 group-hover:opacity-30 transition-opacity duration-300"
                style={{
                  background: `radial-gradient(circle, ${provider.color} 0%, transparent 70%)`,
                  filter: 'blur(20px)'
                }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
